import usePopup from '../../../../hooks/usePopup';
import { ModalTransition } from '@atlaskit/modal-dialog';

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { UnsavedChangesConfirmation } from '../../../ConfirmationModal';
import SingleUseMetricPopupContext from '../../../../contexts/SingleUseMetricPopupContext';
import { InjectedComponentsContext } from '../../../../contextProviders/InjectedComponentsProvider/context';

const SingleUseMetricBuilderPopup = ({
  isOpen,
  close,
  onSingleUseMetricSaved,
  cancelButtonText,
  datasetRedList,
}: {
  isOpen: boolean;
  close: () => void;
  onSingleUseMetricSaved: (metric: Metrics.Metric) => void;
  cancelButtonText: string;
  datasetRedList?: string[];
}) => {
  const { MetricPopup } = useContext(InjectedComponentsContext);
  const {
    isOpen: isConfirmOpen,
    open: openConfirm,
    close: closeConfirm,
  } = usePopup();

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
  const onPopupCloseConfirmed = useCallback(() => {
    closeConfirm();
    close();
  }, [close, closeConfirm]);

  const onPopupDismissed = useCallback(() => {
    if (!hasUnsavedChanges) {
      onPopupCloseConfirmed();
      return;
    }

    openConfirm();
  }, [hasUnsavedChanges, onPopupCloseConfirmed, openConfirm]);

  const [isSaveToDataManager, setIsSaveToDataManager] =
    useState<boolean>(false);

  useEffect(() => {
    setIsSaveToDataManager(false);
    setHasUnsavedChanges(false);
  }, [isOpen]);

  return (
    <SingleUseMetricPopupContext.Provider
      value={{
        isSingleUsePopup: true,
        onSingleUseMetricSaved,
        isSaveToDataManager,
        setIsSaveToDataManager,
        cancelButtonText,
        datasetRedList,
      }}
    >
      <ModalTransition>
        {isOpen && (
          <MetricPopup
            mode="Metric"
            close={onPopupDismissed}
            hasUnsavedChanges={hasUnsavedChanges}
            setHasUnsavedChanges={setHasUnsavedChanges}
          />
        )}
      </ModalTransition>
      <UnsavedChangesConfirmation
        onConfirmed={onPopupCloseConfirmed}
        close={closeConfirm}
        isOpen={isConfirmOpen}
      />
    </SingleUseMetricPopupContext.Provider>
  );
};

export default SingleUseMetricBuilderPopup;
